/**
 * Our server return error message as a json string of type {type, traceId, message, status}, we won't want to show anything other than the actual message to the user, so we want to use JSON.parse(error.message).message .
 * The issue is then for every other type of normal error throw, the error message is just error.message. This helper method helps to try to parse and return the actual message.
 */
export const getSanitizedErrorMessage = (error?: Error) => {
  if (!error) return;
  try {
    const apiErrorObject = JSON.parse(error.message);
    if (apiErrorObject.message) return apiErrorObject.message;
  } catch (e) {}
  return error.message;
};
